import classNames from "classnames";
import connectToStores from "alt-utils/lib/connectToStores";
import get from "lodash/get";
import React, { Component } from "react";

import QuestionStore from "../../stores/chat/QuestionStore";
import ResponseStore from "../../stores/chat/ResponseStore";

import ThreadViewHeaderTitle from "./ThreadViewHeaderTitle";

export class ChatViewHeader extends Component {
    static getStores() {
        return [QuestionStore, ResponseStore];
    }

    static getPropsFromStores() {
        return {
            currentResponse: ResponseStore.getCurrentResponse(),
            hasTerminalAutoResponse: ResponseStore.hasTerminalAutoResponse(),
            isLoading: ResponseStore.getState().isLoading,
            latestAnswerForCurrentResponse: ResponseStore.getLatestAnswerForCurrentResponse(),
            latestAnswerForAllResponses: ResponseStore.getLatestAnswerForAllResponses(),
            question: QuestionStore.getQuestion(),
            questionIsOneOnOne: QuestionStore.isOneOnOne(),
            questionIsRerouted: QuestionStore.questionIsRerouted(),
            responses: ResponseStore.getResponses(),
            responsesHaveAnswers: ResponseStore.allResponsesHaveAnswers(),
            showResponseSwitcher: ResponseStore.getState().showResponseSwitcher,
            unreadResponses: ResponseStore.getUnreadResponses(),
        };
    }

    render() {
        const {
            currentResponse,
            hasTerminalAutoResponse,
            isLoading,
            latestAnswerForCurrentResponse,
            latestAnswerForAllResponses,
            question,
            questionIsOneOnOne,
            questionIsRerouted,
            responses,
            responsesHaveAnswers,
            showResponseSwitcher,
            unreadResponses,
        } = this.props;
        const headerTitleClassNames = classNames({
            "header-title": true,
            "is-loading": isLoading,
        });

        let header = null;
        if (responsesHaveAnswers) {
            header = (
                <ThreadViewHeaderTitle
                    currentResponseId={get(currentResponse, "id", -1)}
                    latestAnswerForCurrentResponse={latestAnswerForCurrentResponse}
                    latestAnswerForAllResponses={latestAnswerForAllResponses}
                    question={question}
                    questionIsOneOnOne={questionIsOneOnOne}
                    responses={responses}
                    showResponseSwitcher={showResponseSwitcher}
                    unreadResponses={unreadResponses}
                />
            );
        } else {
            let headerTitle;

            if (isLoading) {
                headerTitle = i18n.t("rtm.header.loading");
            } else if (question.dateClosed || questionIsRerouted) {
                headerTitle = i18n.t("rtm.header.your_question");
            } else if (hasTerminalAutoResponse) {
                headerTitle = "";
            } else {
                headerTitle = i18n.t("rtm.header.notifying_experts");
            }
            header = <h1 className={headerTitleClassNames}>{headerTitle}</h1>;
        }

        return header;
    }
}

export default connectToStores(ChatViewHeader);
